import { useEffect, useRef } from "react"
import InputItem from "../../components/InputItem"
import ImageUploadInput, { ImageUploadInputRef } from "../../components/ImageUploadInput"
import Loading from "../../components/Loading"
import CStack from "../../components/CStack"
import { useHomeStore } from "../../api/personalization/home/store"
import EditorControl from "../../components/EditorControl"

const AppHome = () => {
  const { retrieveData, data, loading, updateData } = useHomeStore(state => state)
  
  // Create refs for each image upload input
  const imageRefs = useRef<(ImageUploadInputRef | null)[]>([])

  useEffect(() => {
    retrieveData()
  }, [])

  const onApplyEdit = async (newdata: any) => {
    try {
      // Apply all temporary uploads to permanent storage
      const imagePromises = imageRefs.current.map(async (ref, index) => {
        if (ref?.hasTemporaryFile()) {
          const n = index + 1
          const id = `homePageImage${n}URL`
          const permanentUrl = await ref.apply()
          return { id, url: permanentUrl }
        }
        return null
      })

      const imageResults = await Promise.all(imagePromises)
      
      // Update data with permanent URLs
      const updatedData = { ...newdata }
      imageResults.forEach(result => {
        if (result && result.url) {
          updatedData[result.id] = result.url
        }
      })

      // Update the data in the store
      await updateData(updatedData)
      console.log("Changes applied successfully:", updatedData)
    } catch (error) {
      console.error("Error applying changes:", error)
      throw error // Re-throw to let EditorControl handle the error
    }
  }

  return <>
    {loading && <Loading expandHeight />}
    {data !== null && <>
      <EditorControl defaultData={data} onApply={onApplyEdit}>
      { (editedData, onChanged, edit) => <>
          <CStack header="Ad Images">
            {[1, 2, 3, 4, 5].map((n, index) => {
              const id = `homePageImage${n}URL`;
              const url = editedData![id];

              return  (
                <ImageUploadInput
                  ref={el => imageRefs.current[index] = el}
                  key={id}
                  id={id}
                  text={`Image ${n}`}
                  value={url}
                  permanentPath="home"
                  edit={edit}
                  onChanged={onChanged}
                />
              );
            })}
          </CStack>

          <CStack header="Ad Links">
            <InputItem edit={edit} text="Website 1" value={editedData!.homePageAdvertisement1Link} id="homePageAdvertisement1Link" onChanged={onChanged} />
            <InputItem edit={edit} text="Website 2" value={editedData!.homePageAdvertisement2Link} id="homePageAdvertisement2Link" onChanged={onChanged} />
            <InputItem edit={edit} text="Website 3" value={editedData!.homePageAdvertisement3Link} id="homePageAdvertisement3Link" onChanged={onChanged} />
            <InputItem edit={edit} text="Website 4" value={editedData!.homePageAdvertisement4Link} id="homePageAdvertisement4Link" onChanged={onChanged} />
            <InputItem edit={edit} text="Website 5" value={editedData!.homePageAdvertisement5Link} id="homePageAdvertisement5Link" onChanged={onChanged} />
          </CStack>
      
        </>
      }
      </EditorControl>
    </>}
  </>
}

export default AppHome

